import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { jwtCredentials } from '@core/signals/auth.signal';
import { getFullRelativeUrl } from '@core/utils/url.util';

export const authGuard: CanActivateFn = (_route, _state) => {
  const router = inject(Router);

  if (jwtCredentials()?.accessToken) {
    return true;
  }

  return router.createUrlTree(['/login'], {
    queryParams: {
      returnUrl: getFullRelativeUrl(),
    },
  });
};
